import React from 'react'
import ReactDayPickerInput from 'react-day-picker/DayPickerInput';
import { Button, Row, Col } from 'react-bootstrap';
import { ColumnDescription } from 'react-bootstrap-table-next';
import { FaEdit, FaUsers, FaUserLock } from 'react-icons/fa/index';

import { Administration } from '../../lib/dataAccess/DataAccess';
import { IRawStudentExportData } from '../../lib/types/types';

import Navigation from '../../components/navigation/Navigation'
import ErrorMessage from '../../components/visuals/ErrorMessage';
import Loading from '../../components/visuals/Loading';
import Modal from '../../components/Modal';

import { months_long_se, months_short_se, weekdays_long_se, weekdays_short_se } from '../../lib/constants';

interface Props { role: string };
interface State {
    error: string | null,
    isLoading: boolean,
    fetchingRawData: boolean,
    fetchingRawHistData: boolean,
    cancelExport: boolean,
    histStartDate: Date,
    histEndDate: Date
};

export default class RawDataExportPage extends React.Component<Props, State>
{
    constructor(props: Props) 
    {
        super(props)

        this.downloadRawStudentExportData = this.downloadRawStudentExportData.bind(this);
        this.downloadRawStudentExportHistData = this.downloadRawStudentExportHistData.bind(this);
        this.cancelExport = this.cancelExport.bind(this);
        
        let today = new Date();
        let startDate = today.getMonth() > 6 ? new Date(`${today.getFullYear()}-08-01`) : new Date(`${today.getFullYear()-1}-08-01`)
        let endDate = today.getMonth() > 6 ? new Date(`${today.getFullYear()+1}-08-01`) : new Date(`${today.getFullYear()}-08-01`)
        
        this.state = {
            error: null,
            isLoading: true,

            fetchingRawData: false,
            fetchingRawHistData: false,
            cancelExport: false,

            histStartDate: startDate,
            histEndDate: endDate
        }
    }

    componentDidMount() {
    }

    async downloadRawStudentExportData() {
        try {
            this.setState({ fetchingRawData: true, cancelExport: false },
                async () => {
                    try {
                        let rawStudentExportPromise = Administration.RawDataExport.getRawStudentExport();
                        let rawStudentExport = await rawStudentExportPromise;
                
                        if(this.state.cancelExport)
                            return;

                        this.downloadCsv(rawStudentExport, 'Prognosverktyget_rådataexport.csv');
                        this.setState({fetchingRawData: false});
                    } catch (error) {
                        this.setState({error,fetchingRawData: false});
                    }
                });
        } catch (error) {
            this.setState({error,fetchingRawData: false});
        }
    }

    async downloadRawStudentExportHistData() {
        try {
            this.setState({ fetchingRawHistData: true, cancelExport: false },
                async () => {
                    try {
                        const { histStartDate, histEndDate } = this.state;
                        let rawStudentExportPromise = Administration.RawDataExport.getRawStudentExportHist(histStartDate, histEndDate);
                        let rawStudentExport = await rawStudentExportPromise;
                
                        if(this.state.cancelExport)
                            return;

                        console.log({rawStudentExport});

                        this.downloadCsv(rawStudentExport, 'Prognosverktyget_rådataexport.csv');
                        this.setState({fetchingRawHistData: false});
                    } catch (error) {
                        this.setState({error,fetchingRawHistData: false});
                    }
                });
        } catch (error) {
            this.setState({error,fetchingRawHistData: false});
        }
    }

    cancelExport() {
        this.setState({cancelExport: true, fetchingRawData: false, fetchingRawHistData: false });
    }

    downloadCsv(data: IRawStudentExportData[], fileName: string) {
        const headers = `${'Förnamn'};${'Efternamn'};${'Personnummer'};${'Flicka/Pojke'};${'Poäng'};` +
                        `${'Årkurs'};${'Betyg'};${'Prognos'};${'Program'};` +
                        `${'Enhetskod'};${'Enhetsnamn'};${'Gruppnamn'};${'Kurstyp'};${'Kurskod'};${'Kursnamn'};` + 
                        `${'Klassnamn'};${'Kursstart'};${'Kursavslut'};\r\n`;

        const resultString = headers + data.map(dr => {
            return `${dr.studentFirstName};${dr.studentLastName};${dr.studentSSN};${dr.studentGender == 'K' ? 'F' : dr.studentGender == 'M' ? 'P' : ''};${dr.studentPoints || ''};` +
                   `${dr.schoolYear || ''};${dr.studentGrade || ''};${dr.studentPrognosis || ''};${dr.studentProgram};` +
                   `${dr.schoolUnitCode};${dr.schoolUnitName};${dr.groupName};${dr.courseTypeName};${dr.courseName};${dr.courseDisplayName};` + 
                   `${dr.className};${dr.courseInstanceStartDate ? dr.courseInstanceStartDate.slice(0, 10) : ''};${dr.courseInstanceEndDate ? dr.courseInstanceEndDate.slice(0, 10) : ''};`;
        }).join('\r\n');

        
        //@ts-ignore
        if (navigator.msSaveBlob) { // IE 10+
        
            var blob = new Blob(['data:text/csv;charset=utf-8,%EF%BB%BF' + resultString], { type: 'text/csv;charset=utf-8;' });
            //@ts-ignore
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { 
                link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(resultString));
                link.setAttribute("download", fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    render() {

        const { error, fetchingRawData, fetchingRawHistData } = this.state;
        const fetching = fetchingRawData || fetchingRawHistData;

        return (
            <div className="render-adminPage">
                <Navigation role={ this.props.role } />
                <Modal size="lg" title={"Förbereder dataexport..."} promtHide={false} show={fetching} onHide={this.cancelExport} style={{backgroundColor:'green', width: '50%'}}>
                    <div>
                        <Loading>
                            <br/>
                            <Button onClick={this.cancelExport}>Avbryt</Button>
                        </Loading>
                    </div>
                    <div style={{textAlign: 'right'}}>
                    </div>
                </Modal>
                <div  className="junit-container container-fit" style={{overflow:'auto', height:'100%', paddingBottom: '20rem',paddingTop: '1rem'}}>
                    <ErrorMessage hidden={error === null}>{error}</ErrorMessage>
                    <h3>Rådataexport</h3>
                    <div style={{padding: '1rem 0'}}>
                        <Row>
                            <Col md={10} xs={12}>
                                <h4>Aktuell data</h4>
                                <span>
                                    Hämta den senaste datan för samtliga elever
                                </span>
                                <br/>
                            </Col>
                            <Col md={2} xs={12} style={{textAlign: 'right', paddingTop: '2rem'}}>
                                <Button style={{width: '100%'}} disabled={fetching} onClick={this.downloadRawStudentExportData}>
                                    Hämta
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <div style={{padding: '1rem 0', borderTop: 'solid 1px lightgrey'}}>
                        <Row>
                            <Col md={4} xs={12}>
                                <h4>Intervall data</h4>
                                <span>
                                    Hämta all elevdata för det angivna intervallet
                                </span>
                                <br/>
                            </Col>
                            <Col md={6} xs={12} style={{paddingTop: '2rem'}}>
                                <div style={{marginBottom: 10}}>
                                    <div style={{ display: 'inline-block'}}>
                                        <span style={{fontSize:'1.25rem', marginRight: '0.5rem'}}>Från:</span> 
                                        <ReactDayPickerInput 
                                            formatDate={(date) => date.toISOString().slice(0, 10)}
                                            value={this.state.histStartDate}
                                            placeholder={'ÅÅÅÅ-MM-DD'}
                                            inputProps={{ style:{ textAlign:'center', borderRadius: '0.25rem', borderWidth:'1px' } }}
                                            dayPickerProps={{
                                                locale: 'sv',
                                                months: months_long_se,
                                                weekdaysLong: weekdays_long_se,
                                                weekdaysShort: weekdays_short_se
                                            }}
                                            onDayChange={(e) => this.setState({histStartDate: e})}
                                        />
                                    </div>
                                    <div style={{ display: 'inline-block', padding: '0 1rem'}}>
                                        <span style={{fontSize:'1.25rem', marginRight: '0.5rem'}}>Till:</span> 
                                        <ReactDayPickerInput 
                                            formatDate={(date) => date.toISOString().slice(0, 10)}
                                            value={this.state.histEndDate}
                                            placeholder={'ÅÅÅÅ-MM-DD'}
                                            inputProps={{ style:{ textAlign:'center', borderRadius: '0.25rem', borderWidth:'1px' } }}
                                            dayPickerProps={{
                                                locale: 'sv',
                                                months: months_long_se,
                                                weekdaysLong: weekdays_long_se,
                                                weekdaysShort: weekdays_short_se
                                            }}
                                            onDayChange={(e) => this.setState({histEndDate: e})}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col md={2} xs={12} style={{textAlign: 'right', paddingTop: '2rem'}}>
                                <Button disabled={fetching} style={{width: '100%'}} onClick={this.downloadRawStudentExportHistData}>Hämta</Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        )
    }
}
